import * as React from 'react';
import { useSelector } from 'react-redux';

import { Tour, TourSlide } from 'shared/components/TourSlide';
import { virtualTourBannerImageUrlSelector } from 'shared/selectors/newObject/getTourBannerImageUrl';

import { track3DTourBlockClick } from './tracking';
import { virtualTourKeySelector } from '../../selectors/newObject/getTour';

export function TourSlideContainer() {
  const [open, setOpen] = React.useState(false);
  const tourFrameRef = React.useRef<HTMLIFrameElement>(null);

  const tourKey = useSelector(virtualTourKeySelector);
  const tourBannerImageUrl = useSelector(virtualTourBannerImageUrlSelector);

  const handleTourShow = React.useCallback(() => {
    setOpen(true);
    track3DTourBlockClick();
  }, []);

  if (!tourKey || !tourBannerImageUrl) {
    return null;
  }

  return (
    <>
      {!open && <TourSlide tourBannerImageUrl={tourBannerImageUrl} onClick={handleTourShow} />}
      {open && <Tour frameRef={tourFrameRef} tourUrl={tourKey} />}
    </>
  );
}
